import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { OfferService } from '../../_services/offer.service';
import { CartService } from '../../_services/cart.service';
import { StoreService } from '../../_services/store.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { getPrice } from '../../_models/offer';

@Component({
    selector: 'app-seller-products',
    templateUrl: './seller-products.component.html',
    styleUrls: ['./seller-products.component.css'],
    standalone: false
})
export class SellerProductsComponent implements OnInit {
    userId: number;
    sellerName = '';
    offers: any[] = [];
    loading = true;
    page = 1;
    totalItems = 0;
    itemsPerPage = 20;
    lang = 'en';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private offerService: OfferService,
        private cartService: CartService,
        private storeService: StoreService,
        private translateService: TranslateService,
        private toastrService: ToastrService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.userId = +this.route.snapshot.paramMap.get('userId');
        this.lang = this.translateService.currentLang || 'en';
    }

    ngOnInit(): void {
        this.loadSellerProducts();
        if (isPlatformBrowser(this.platformId)) {
            window.scrollTo(0, 0);
        }
    }

    loadSellerProducts(): void {
        this.loading = true;
        this.offerService.loadOffersBySeller(this.userId, this.page).subscribe(
            (response: any) => {
                this.offers = response.data || [];
                this.totalItems = response.totalOfItems || 0;
                this.itemsPerPage = response.itemPerPage || 20;
                if (this.offers.length > 0 && this.offers[0].user) {
                    const user = this.offers[0].user;
                    this.sellerName = (user.firstName || '') + ' ' + (user.lastName || '');
                }
                this.loading = false;
            },
            () => {
                this.offers = [];
                this.loading = false;
            }
        );
    }

    pageChange(page: number): void {
        this.page = page;
        this.loadSellerProducts();
        if (isPlatformBrowser(this.platformId)) {
            window.scrollTo(0, 0);
        }
    }

    getImageSrc(offer: any): string {
        if (offer.defaultPicture && offer.defaultPicture.length > 0) {
            return environment.image_cdn_url + '/' + offer.defaultPicture + '?func=cropfit&width=366&dpr=1.75&quality=100';
        }
        return offer.product && offer.product.picture
            ? environment.image_cdn_url + '/' + offer.product.picture
            : '/assets/images/default.jpg';
    }

    getOfferPrice(offer: any): number {
        return getPrice(offer);
    }

    isInPromotion(offer: any): boolean {
        return offer.pricing && offer.pricing.nicename === 'promotion';
    }

    isOfferInCart(offer: any): any {
        return this.storeService.findItem(offer.id);
    }

    addToCart(offer: any): void {
        this.cartService.addToLocalCart(offer).subscribe(() => {
            this.translateService.get('common.message_for_added_to_cart').subscribe(message => {
                this.toastrService.success(message);
            });
        });
    }

    addToWishlist(offerId: number): void {
        this.router.navigate(['/login']);
    }

    stripHtml(html: string): string {
        if (!html) return '';
        return html.replace(/<[^>]*>/g, '').trim();
    }
}
